const routes = [
  {
    path: '/actividadesprogramadas',
    name: 'despachador',
    component: () => import('@/views/ActividadesProgramadas/ActividadesProgramadas')
  },
  {
    path: '/actividadesprogramadas/nuevo',
    name: 'actividadesprogramadas.nuevo',
    meta: { withoutPermissions: true },
    component: () => import('@/views/ActividadesProgramadas/Guardar')
  }, {
    path: '/actividadesprogramadas/editar/:id',
    name: 'actividadesprogramadas.editar',
    meta: { withoutPermissions: true },
    component: () => import('@/views/ActividadesProgramadas/Guardar')
  }, {
    path: '/actividadesprogramadas/ver/:id/:ver',
    name: 'actividadesprogramadas.ver',
    meta: { withoutPermissions: true },
    component: () => import('@/views/ActividadesProgramadas/Guardar')
  },
  {
    path: '/actividadesprogramadas/configuracion',
    name: 'actividadesprogramadas.configuracion',
    component: () => import('@/views/ActividadesProgramadas/Configuracion/Configuracion')
  }, {
    path: '/actividadesprogramadas/configuracion/estados',
    name: 'actividadesprogramadas.configuracion.estados',
    component: () => import('@/views/ActividadesProgramadas/Configuracion/Estado')
  }, {
    path: '/actividadesprogramadas/configuracion/tipoactividades',
    name: 'actividadesprogramadas.configuracion.tipoactividades',
    component: () => import('@/views/ActividadesProgramadas/Configuracion/TipoActividad')
  },

  {
    path: '/actividadesprogramadas/contactos',
    name: 'actividadesprogramadas.contactos',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Contactos')
  }, {
    path: '/actividadesprogramadas/contactos/nuevo',
    name: 'actividadesprogramadas.contactos.nuevo',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Guardar')
  }, {
    path: '/actividadesprogramadas/contactos/editar/:id',
    name: 'actividadesprogramadas.contactos.editar',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Guardar')
  },

  {
    path: '/actividades',
    name: 'actividades',
    component: () => import('@/views/ActividadesProgramadas/Actividades/Actividades')
  }, {
    path: '/actividades/:id/detalles',
    name: 'actividades.editar',
    meta: { detalles: true },
    component: () => import('@/views/ActividadesProgramadas/Guardar')
  }, {
    path: '/actividades/nuevo',
    name: 'actividades.nuevo',
    meta: { detalles: true },
    component: () => import('@/views/ActividadesProgramadas/Guardar')
  }, {
    path: '/mapa',
    name: 'actividades.mapa',
    component: () => import('@/views/ActividadesProgramadas/Actividades/Mapa')
  }, {
    path: '/checklist/:id',
    name: 'actividadesprogramadas.checklist',
    component: () => import('@/views/ActividadesProgramadas/Mobile/Checklist')
  }, {
    path: '/notas/:id',
    name: 'actividadesprogramadas.notas',
    component: () => import('@/views/ActividadesProgramadas/Mobile/Notas')
  }, {
    path: '/archivos/:id',
    name: 'actividadesprogramadas.archivos',
    component: () => import('@/views/ActividadesProgramadas/Mobile/Archivos')
  }, {
    path: '/datos/:id',
    name: 'actividadesprogramadas.datos',
    component: () => import('@/views/ActividadesProgramadas/Mobile/Datos')
  }, {
    path: '/calendario',
    name: 'calendario',
    component: () => import('@/views/ActividadesProgramadas/Actividades/Calendario')
  },

  {
    path: '/casos/:id',
    name: 'actividadesprogramadas.casoscon',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Tabs/Casos')
  }, {
    path: '/notas/:id',
    name: 'actividadesprogramadas.notascon',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Tabs/Notas')
  }, {
    path: '/archivos/:id',
    name: 'actividadesprogramadas.archivoscon',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Tabs/Archivos')
  }, {
    path: '/datos/:id',
    name: 'actividadesprogramadas.datoscon',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Tabs/Datos')
  }, {
    path: '/encuestas/:id',
    name: 'actividadesprogramadas.encuestascon',
    component: () => import('@/views/ActividadesProgramadas/Contactos/Tabs/Encuestas')
  }
]

export default routes
